// extracted by mini-css-extract-plugin
export default {"button":"RemoveButton_button__BHRTb"};